import { useCallback, useEffect } from 'react';
import useAlertNotify from 'src/components/Toasts/AlertNotifications/hooks/useAlertNotify';
import useAppEventEmitter from 'src/hooks/useAppEventEmitter';
import useGoToRoute from 'src/hooks/useGoToRoute';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

export default function useEventEmitterAlertNotificationListener() {
	const appEventEmitter = useAppEventEmitter();
	const alertNotify = useAlertNotify();

	const setAccountStore = useDriftAccountStore((s) => s.set);
	const goToRoute = useGoToRoute();

	const handleDownloadReady = useCallback(() => {
		const handleSeen = () => {
			setAccountStore((s) => {
				s.downloadFiles.newAvailableDetected = false;
			});
		};

		const goToDownload = () => {
			handleSeen();
			goToRoute('/portfolio/history?table=exports');
		};

		alertNotify({
			id: 'download-ready-alert',
			alertType: 'minor',
			message: 'Download ready!',
			description: 'Your statement is ready for download.',
			action: {
				label: 'View now',
				callback: goToDownload,
			},
			onDismiss: handleSeen,
			disableAlertAutoDismiss: true,
		});
	}, [alertNotify, goToRoute, setAccountStore]);

	useEffect(() => {
		appEventEmitter.on('downloadReady', handleDownloadReady);

		return () => {
			appEventEmitter.off('downloadReady', handleDownloadReady);
		};
	}, [appEventEmitter, handleDownloadReady]);
}
